import glamorous from 'glamorous'

const Container = glamorous.div(
  {
    margin: '0 auto',
    maxWidth: '34rem',
    width: '100%',
  },
  ({ isMobile = false }) => ({
    display: 'block',
    padding: isMobile ? '10px' : 'unset',
  })
)

const SpecificCardContainer = glamorous.div(
  {
    position: 'relative',
    display: 'flex',
    marginTop: '60px',
    marginBottom: '36px',
    textAlign: 'center',
  },
  ({ isMobile = false }) => ({
    textAlign: 'left',
    flexDirection: isMobile ? 'row' : 'column',
  })
)

const CardImg = glamorous.img(
  {
    display: 'block',
    height: '100%',
    borderRadius: '4px',
  },
  ({ isMobile = false }) => ({
    margin: isMobile ? '0px 16px 0px 0px' : '0 auto 8px auto',
    width: isMobile ? '25%' : '70px',
  })
)

const CardDetailsContainer = glamorous.div(
  {
    display: 'block',
  },
  ({ isMobile = false }) => ({
    textAlign: isMobile ? 'left' : 'center',
  })
)

const CardDetail = glamorous.span({
  display: 'block',
})

const CardIconContainer = glamorous.div(
  {
    position: 'relative',
    display: 'block',
    width: '48px',
  },
  ({ isMobile }) => ({
    margin: isMobile ? 'unset' : '20px auto',
  })
)

const WarningIcon = glamorous.span(
  {
    color: 'orange',
    position: 'absolute',
    bottom: 0,
    right: '-5px',
    clipPath: 'circle(10px at center)',
    backgroundColor: 'white',
  },
  'ppvx_icon ppvx_icon--size_xs ppvx_icon-warning-alt'
)

const Title = glamorous.h1(
  {
    // defaults
  },
  ({ isMobile = false }) => ({
    textAlign: isMobile ? 'left' : 'center',
    margin: isMobile ? '36px 0 8px 0' : '24px 10% 12px 10%',
  })
)

const Paragraph = glamorous.p(
  {
    display: 'inline-block',
  },
  ({ isMobile = false }) => ({
    margin: isMobile ? '0.875rem 0' : '1rem 10%',
    textAlign: isMobile ? 'left' : 'center',
  })
)

const Button = glamorous.button(
  {
    display: 'block',
    margin: '1.25rem auto',
  },
  ({ isMobile = false }) => ({
    width: isMobile ? '100%' : '308px',
  })
)

export {
  Container,
  SpecificCardContainer,
  CardImg,
  CardDetailsContainer,
  CardDetail,
  CardIconContainer,
  WarningIcon,
  Title,
  Paragraph,
  Button,
}
